import { render } from "./_ChatGiphy.vue?vue&type=template&id=79dd9594"
import script from "./_ChatGiphy.vue?vue&type=script&lang=js"
export * from "./_ChatGiphy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__